<template>
<div class="field__radio-buttons">
    <div class="control">
        <label class="radio" v-for="opt in config.options"><input type="radio" :name="config.name" :value="opt.value" :checked="opt.checked" /> <span :class="[{'has-text-danger': isWhitepaper && opt.label == 'No'}, {'has-text-success': isWhitepaper && opt.label == 'Yes'}]">{{opt.label}}</span></label>
    </div>
    <p v-if="config.label" class="help">{{config.label}}</p>
</div>
</template>

<script>
export default {
    name    :   'Radio',
    props   :   ['config'],
    computed: {
        isWhitepaper() {
            return this.$parent ? this.$parent.$options.name == 'WhitepaperForm' : false;
        }
    },
    methods: {
        confirm_no(e) {
            if (e.target.name == 'Subscribed' && e.target.value == 0) {
                if (!confirm('You selected “NO”.\n\nAre you sure? You don’t want to receive any invites for our webinars or workshops?\n\nWe hope that this is not the case. Let’s stay connected by selecting “YES”.\n\nBe part of the thinkstep community and succeed sustainably.')) {
                    $(this.$el).find('input[name="Subscribed"][value="1"]').prop('checked', true);
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/formfields/Radio.vue